import * as React from 'react';
import * as shortId from 'shortid';

interface TileProps {
    tileHead: JSX.Element;
    tileBody: JSX.Element;
    tileFunction?: () => void | undefined;
}

class Tile extends React.Component<TileProps, {}> {
    constructor(props: TileProps) {
        super(props);
        this.callBack = this.callBack.bind(this);
    }

    callBack() {
        if (this.props.tileFunction) {
            this.props.tileFunction();
        }
    }

    public render() {
        return (
            <div
                onClick={this.callBack}
                key={shortId.generate()}
                className="item tile"
            >
                <div className="tileHead">
                    {this.props.tileHead}
                </div>
                <div className="tileBody">
                    {this.props.tileBody}
                </div>
            </div>
        );
    }
}
export default Tile;


// WEBPACK FOOTER //
// ./src/components/tileWall/tile.tsx